import { isCoreElement } from '@tunasong/schemas'
import type { CoreElement } from '@tunasong/schemas'

export interface Blockquote extends CoreElement {
  type: 'blockquote'
}

export function isBlockquote(node?: unknown): node is Blockquote {
  return Boolean(isCoreElement(node) && node.type === 'blockquote')
}
